import WebWorkers from "./WebWorkers";
export default WebWorkers;
